import { Box, TextField, Typography } from '@mui/material'
import { resetPassword } from 'auth/utils'
import Button from 'common/components/Button'
import { ErrorMessage } from 'common/components/ErrorMessage'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import isEmail from 'validator/lib/isEmail'

export const ResetPasswordView = ({ email, setEmail, setQuery }) => {
  const [hasResetPassword, setHasResetPassword] = useState(false)
  const [error, setError] = useState(false)

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      }}
      onSubmit={async (event) => {
        event.preventDefault()
        try {
          if (!isEmail(email)) {
            throw new Error('Enter a valid email')
          }
          setError(null)
          setHasResetPassword(true)
          await resetPassword(email)
        } catch (err) {
          setError(
            err.response?.data?.error ||
              err.response?.data?.message ||
              err?.message ||
              'Unable to reset password'
          )
        }
      }}
    >
      {hasResetPassword ? (
        <>
          <Typography variant="textPrimary" sx={{ textAlign: 'center' }}>
            Password reset has been sent
          </Typography>
          <Button
            onClick={() => {
              setHasResetPassword(false)
              setError(null)
              setQuery({ view: 'signIn' })
            }}
            sx={{
              width: '100%',
            }}
          >
            Login
          </Button>
        </>
      ) : (
        <>
          <TextField
            InputLabelProps={{
              color: 'secondary',
            }}
            label="Email"
            name="email"
            autoFocus
            fullWidth
            value={email}
            color={'primary'}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button color="primary" variant="contained" type="submit" sx={{ width: '100%' }}>
            Submit
          </Button>
          <Button
            variant="text"
            startIcon={<ArrowLeft />}
            onClick={() => {
              setQuery({ view: 'signIn' })
            }}
          >
            Back
          </Button>
        </>
      )}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Box>
  )
}
